import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiscService } from '../../../services/misc/misc.service';
import { TooltipDirective } from '../../../common/directives/tooltip/tooltip.directive';
import { TruncatePipe } from '../../../pipes/truncate/truncate';
import { RakutenAffiliateAssignmentDrawerContext } from './rakuten-affiliate-assignment.types';

@Component({
  selector: 'app-rakuten-affiliate-assignment',
  standalone: true,
  imports: [CommonModule, TooltipDirective, TruncatePipe],
  templateUrl: './rakuten-affiliate-assignment.component.html',
  styleUrl: './rakuten-affiliate-assignment.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RakutenAffiliateAssignmentComponent {
  @ViewChild('drawerDialog', { static: false }) drawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('openDrawerButton', { static: false }) openDrawerButton?: ElementRef<HTMLButtonElement>;

  readonly miscService = inject(MiscService);
  readonly assignment = signal<RakutenAffiliateAssignmentDrawerContext | null>(null);

  open(context: RakutenAffiliateAssignmentDrawerContext): void {
    this.assignment.set(context);
    // el-dialog can auto-close if showModal runs before the panel has layout.
    // Prefer Invoker Commands after paint (same pattern as Shopify drawer).
    this.scheduleDrawerOpen();
  }

  private scheduleDrawerOpen(): void {
    const tryOpen = (): void => {
      const btn = this.openDrawerButton?.nativeElement;
      if (btn) {
        btn.click();
        return;
      }

      const dialog = this.drawerDialog?.nativeElement;
      const host = dialog?.closest('el-dialog') as (HTMLElement & { show?: () => void }) | null;
      if (host && typeof host.show === 'function') {
        host.show();
        return;
      }

      if (dialog && !dialog.open) {
        dialog.showModal();
      }
    };

    requestAnimationFrame(() => requestAnimationFrame(tryOpen));
  }

  closePanel(): void {
    this.drawerDialog?.nativeElement?.close();
  }

  copyItem(value: string | null | undefined, label: string): void {
    if (!value) {
      return;
    }
    this.miscService.copyToClipboard(value, label);
  }
}
